import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getServicewiseRevenue } from "../../services/servicerevenue.services";

export const fetchServicewiseRevenue = createAsyncThunk(
  "servicewiseRevenue/fetch",
  async (groupBy, { rejectWithValue }) => {
    try {
      const data = await getServicewiseRevenue(groupBy);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const serviceRevenueSlice = createSlice({
  name: "servicewiseRevenue",
  initialState: {
    monthly: [], // Monthly revenue data
    yearly: [], // Yearly revenue data
    status: "idle", // idle | loading | succeeded | failed
    error: null, // Error message
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServicewiseRevenue.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchServicewiseRevenue.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (action.meta.arg === "month") {
          state.monthly = action.payload.monthly_servicewise_revenue;
        } else if (action.meta.arg === "year") {
          state.yearly = action.payload.yearly_servicewise_revenue;
        }
      })
      .addCase(fetchServicewiseRevenue.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default serviceRevenueSlice.reducer;
